import { Smartphone, BatteryCharging, Plug, Tablet, Laptop, ArrowUpRight } from "lucide-react";

const SERVICES = [
  { key: "Screen replacement", icon: Smartphone, title: "Screen Replacements", text: "Cracked, black or unresponsive screen? We replace screens on iPhones, Samsung and more." },
  { key: "Battery replacement", icon: BatteryCharging, title: "Battery Replacements", text: "Phone dying by lunchtime? A new battery brings back all-day charge." },
  { key: "Charging port repair", icon: Plug, title: "Charging Port Repairs", text: "Loose cable, slow charging or not charging at all — we clean, repair or replace the port." },
  { key: "Tablet repair", icon: Tablet, title: "Tablet Repairs", text: "iPads and Android tablets — screens, batteries, ports and more." },
  { key: "Laptop repair", icon: Laptop, title: "Laptop Repairs", text: "Screens, keyboards, batteries and slow-running laptops looked at properly." },
];

const REPAIR_IMG = "https://images.pexels.com/photos/6754839/pexels-photo-6754839.jpeg?auto=compress&cs=tinysrgb&w=1200";

export const RepairServices = ({ onBookRepair }) => (
  <section id="repairs" className="py-20 md:py-28 bg-white" data-testid="repairs-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-brand-600">Repairs</p>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl font-black tracking-tight text-ink">Professional Phone, Tablet & Laptop Repairs</h2>
          <p className="mt-3 text-slate-600 max-w-xl">Bring it in or message us first. We'll tell you honestly what's wrong and what it'll cost before any work starts.</p>
        </div>
        <div className="lg:col-span-5 lg:text-right">
          <button onClick={() => onBookRepair()} className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 font-display font-bold text-white hover:bg-brand-600 transition-colors" data-testid="repairs-book-btn">BOOK A REPAIR</button>
        </div>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <figure className="relative rounded-2xl overflow-hidden bg-ink min-h-[260px] md:row-span-2 lg:row-span-3">
          <img src={REPAIR_IMG} alt="Technician repairing a device" className="absolute inset-0 h-full w-full object-cover opacity-80" />
          <figcaption className="absolute inset-x-0 bottom-0 p-6 bg-ink/70 backdrop-blur-md text-white">
            <p className="font-display text-xl font-bold">Repaired in Dungannon</p>
            <p className="text-sm text-slate-300 mt-1">47 Market Square — call in or message ahead.</p>
          </figcaption>
        </figure>
        {SERVICES.map(({ key, icon: Icon, title, text }) => (
          <button key={key} onClick={() => onBookRepair(key)} className="group text-left rounded-2xl border border-slate-200 p-6 md:p-7 hover:border-brand-600 hover:shadow-xl transition-[border-color,box-shadow] duration-300" data-testid={`repair-service-${key.split(" ")[0].toLowerCase()}`}>
            <div className="flex items-start justify-between">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-colors"><Icon className="h-6 w-6" /></span>
              <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-brand-600 transition-colors" />
            </div>
            <h3 className="font-display mt-5 text-xl font-bold text-ink">{title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{text}</p>
            <p className="mt-4 text-sm font-bold text-brand-600">Get a quote →</p>
          </button>
        ))}
        <button onClick={() => onBookRepair("Something else")} className="text-left rounded-2xl bg-ink text-white p-6 md:p-7 hover:bg-brand-600 transition-colors" data-testid="repair-service-other">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-brand-400">Something else?</p>
          <h3 className="font-display mt-4 text-xl font-bold">Not sure what's wrong?</h3>
          <p className="mt-2 text-sm text-slate-300">Water damage, buttons, cameras, speakers — tell us the problem and we'll give you honest advice.</p>
          <p className="mt-4 text-sm font-bold">Ask us →</p>
        </button>
      </div>
    </div>
  </section>
);
